// extracted by mini-css-extract-plugin
export default {"tooltip-container":"Tooltip_tooltip-container__x-7zx","tooltip-box":"Tooltip_tooltip-box__rDQLm"};